import React, { useState } from 'react';
import { FormValues as Experience } from '../../../../types/experience';
import { Box, Typography } from '@mui/material';
import AddOnList from './AddOnList';
import OptionalServiceList from './OptionalServiceList';
import { AvailableOptionalService } from '../../EditReservation/optionalServiceAvailability';
import { ViewKey } from '../ViewIndividualReservation';

const AddOnSection = ({
    experience,
    hasAddOns,
    hasOptionalServices,
    setShowItineraryForm,
    setIsAddOnForm,
    setTab,
    tab,
    originalTab,
    setOriginalTab,
    setPreselectedAddOn,
    setPreselectedPartnerService,
}: {
    experience: Experience;
    hasAddOns: boolean;
    hasOptionalServices: boolean;
    setShowItineraryForm: (show: boolean) => void;
    setIsAddOnForm: (show: boolean) => void;
    setTab: (tab: ViewKey) => void;
    tab: ViewKey;
    originalTab: string;
    setOriginalTab: (tab: ViewKey) => void;
    setPreselectedAddOn: (addOn: { id: number; type: string } | null) => void;
    setPreselectedPartnerService: (selected: boolean) => void;
}) => {
    const handleOptionalServiceSelect = (
        _service: AvailableOptionalService,
    ) => {
        setOriginalTab(tab);
        setPreselectedAddOn(null);
        setPreselectedPartnerService(true);
        setTab('itinerary');
        setShowItineraryForm(true);
        setIsAddOnForm(true);
    };

    return (
        <Box sx={{ px: 2 }}>
            <Typography sx={{ fontWeight: 'bold' }}>
                {hasAddOns ? 'Add-ons' : 'Enhance your stay'}
            </Typography>
            <Typography variant='body2'>
                {hasAddOns && hasOptionalServices
                    ? 'Add-on experiences and partner services'
                    : hasAddOns
                      ? 'Enhance your stay'
                      : 'Partner services for your reservation'}
            </Typography>
            <Box
                sx={{
                    maxHeight: 300,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    pr: 0.5,
                }}
            >
                {hasAddOns && (
                    <AddOnList
                        experience={experience}
                        handleSelect={(addOn) => {
                            setOriginalTab(tab);
                            if (addOn.id == null) return;
                            setPreselectedAddOn({
                                id: addOn.id,
                                type: addOn.type,
                            });
                            setPreselectedPartnerService(false);
                            setTab('itinerary');
                            setShowItineraryForm(true);
                            setIsAddOnForm(true);
                        }}
                    />
                )}
                {hasOptionalServices && (
                    <OptionalServiceList
                        experience={experience}
                        onSelect={handleOptionalServiceSelect}
                    />
                )}
            </Box>
        </Box>
    );
};

export default AddOnSection;
